import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_TYPE } from '@motorway/mw-highway-code/enums';

import { GA_TAGS, ULEZ_CHECKER_EVENTS } from 'Utilities/analytics';
import { unprettyVRM } from 'Utilities/formValidators';
import { isNull } from 'Utilities/helpers';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import LocalTexts from '../ulezText.json';

import styles from './Demand.scss';

const LocalT = new MDText(LocalTexts);

type DemandProps = {
  expandedBlock?: boolean;
  isCompliant?: boolean | null;
  vrm?: string;
};
const ctaLabel = LocalT.translate('results.valuationLink') as string;
const mileageRoute = '/mileage';

export const Demand = ({ expandedBlock, isCompliant, vrm }: DemandProps) => {
  const onCtaClick = () => {
    const actionLabel = isCompliant ? 'Compliant' : 'Non-Compliant';
    const categoryType = isCompliant ? 'compliant' : 'non_compliant';

    ULEZ_CHECKER_EVENTS.CTA_CLICKED({
      buttonLabel: ctaLabel,
      categoryType,
      label: vrm ? unprettyVRM(vrm) : 'N/A',
      url: mileageRoute,
    });
    GA_TAGS.ULEZ_VALUATION_SUBMITTED(actionLabel, 'Demand for Car');
  };

  return (
    <ComponentContent
      className={
        cx(styles.container, { [styles.expanded]: expandedBlock, [styles.unavailable]: isNull(isCompliant) })
      }
      maxWidth={CONTENT_SIZES.none}
    >
      <h3>{LocalT.translate('results.valuation.title')}</h3>
      <p>{LocalT.translate('results.valuation.subtitle')}</p>
      <Button
        data-thc-button
        fullWidth
        as={ Link }
        icon="chevron"
        label={ctaLabel}
        onClick={onCtaClick}
        to={mileageRoute}
        type={ BUTTON_TYPE.BUTTON }
      />
    </ComponentContent>
  );
};
